var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"support",attrs:{"to":"/profile","aria-label":"support"}},[_vm._v("Profile")])}
var staticRenderFns = []

export { render, staticRenderFns }